// Shared between AdminSailing's "New/Edit Sailing" dialog and the BOL
// Upload review screen, so both pick vessel/port from the same list instead
// of one page letting free text drift from the other's spelling.
export const VESSEL_OPTIONS = ["BF Cartagena", "Carib Voyager"];
export const PORT_OPTIONS = ["Port Everglades, FL", "George Town, Cayman Islands"];

// BOL PDFs print these names in all-caps with their own abbreviations (e.g.
// "PORT EVERGLADES, FLA", "GEORGE TOWN, GRAND CAYMAN") that don't literally
// match our canonical dropdown option strings. Maps a few known raw-text
// variants to the matching VESSEL_OPTIONS/PORT_OPTIONS entry so the BOL
// Upload review screen can pre-select the right option after parsing
// instead of leaving the admin to re-pick it. Lookup is
// trim+uppercase+collapse-whitespace, so spacing/case differences in the
// PDF extract don't block a match.
const VESSEL_ALIASES = {
  "BF CARTAGENA": "BF Cartagena",
  "CARIB VOYAGER": "Carib Voyager",
};
const PORT_ALIASES = {
  "PORT EVERGLADES, FLA": "Port Everglades, FL",
  "PORT EVERGLADES, FL": "Port Everglades, FL",
  "PORT EVERGLADES, FLORIDA": "Port Everglades, FL",
  "GEORGE TOWN, GRAND CAYMAN": "George Town, Cayman Islands",
  "GEORGE TOWN, CAYMAN ISLANDS": "George Town, Cayman Islands",
};

const normalizeKey = (text) => (text || "").trim().toUpperCase().replace(/\s+/g, " ");

// Returns the canonical option string this raw BOL text refers to, or the
// original text unchanged (just trimmed) if it isn't a known variant —
// never discards what the PDF actually said.
export const matchVesselOption = (raw) => VESSEL_ALIASES[normalizeKey(raw)] || (raw || "").trim();
export const matchPortOption = (raw) => PORT_ALIASES[normalizeKey(raw)] || (raw || "").trim();
